// tracker.js - Main tracker file that loads everything
// This file orchestrates the loading and initialization of all tracker components

// ===========================================
// AUTO-INITIALIZATION & EVENT BINDING
// ===========================================

// Enhanced traffic filtering with configuration
(function () {
    const TRACK_ALL_TRAFFIC = true; // Set to false to only track Meta traffic

    if (TRACK_ALL_TRAFFIC) {
        window.tracker = new ShopifyBehavioralTracker();
        return;
    }

    // Meta traffic detection (only used if TRACK_ALL_TRAFFIC = false)
    const referrer = document.referrer.toLowerCase();
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    const utmSource = urlParams.get('utm_source');

    const isMetaTraffic = referrer.includes('facebook.com') ||
        referrer.includes('instagram.com') ||
        referrer.includes('meta.com') ||
        fbclid ||
        (utmSource && utmSource.toLowerCase().includes('facebook')) ||
        (utmSource && utmSource.toLowerCase().includes('instagram')) ||
        (utmSource && utmSource.toLowerCase().includes('meta'));

    const isDirectTraffic = !referrer || referrer === window.location.origin;
    const isOrganicSearch = referrer.includes('google.com') || referrer.includes('bing.com');

    if (isMetaTraffic || isDirectTraffic || isOrganicSearch) {
        window.tracker = new ShopifyBehavioralTracker();
    } else {
        // Dummy tracker for filtered traffic
        window.tracker = {
            track: () => { },
            viewContent: () => { },
            addToCart: () => { },
            initiateCheckout: () => { },
            purchase: () => { },
            emailCaptured: () => { },
            identify: () => { },
            pageVisit: () => { },
            sustainabilityEngaged: () => { },
            soilToSoilEngaged: () => { },
            highProductEngagement: () => { },
            multipleProductViews: () => { },
            socialProofEngaged: () => { },
            returnVisitor: () => { },
            searchPerformed: () => { },
        };
    }
})();


// ===========================================
// AUTO-TRACKING FOR SHOPIFY PAGES
// ===========================================

// FIXED: Page visit tracking with duplicate prevention
(function () {
    const path = window.location.pathname;
    const currentURL = window.location.pathname + window.location.search;

    // FIXED: Create a unique key for this specific page load
    const pageLoadKey = `page_load_${currentURL}_${Date.now()}`;

    // FIXED: Check if we've already tracked this exact page load
    if (sessionStorage.getItem(pageLoadKey)) {
        return; // Already tracked this page load
    }

    // Set the flag immediately to prevent duplicates
    sessionStorage.setItem(pageLoadKey, 'true');

    let pageType = 'other';
    let pageName = document.title || '';

    if (path.includes('/products/')) {
        pageType = 'product';
        pageName = document.querySelector('h1')?.textContent?.trim() || '';
    } else if (path.includes('/collections/')) {
        pageType = 'collection';
        pageName = document.querySelector('h1')?.textContent?.trim() || '';
    } else if (path === '/' || path === '') {
        pageType = 'home';
        pageName = 'Home';
    } else if (path.includes('/cart')) {
        pageType = 'cart';
        pageName = 'Cart';
    } else if (path.includes('/checkout')) {
        pageType = 'checkout';
        pageName = 'Checkout';
    } else if (path.includes('/pages/')) {
        pageType = 'page';
        pageName = document.querySelector('h1')?.textContent?.trim() || '';
    }

    // Get page visit counts (this can still be tracked for analytics)
    const pageKey = `page_${currentURL}`;
    const pageCountKey = `count_${pageKey}`;
    const pageTimesKey = `times_${pageKey}`;
    const lastPageKey = sessionStorage.getItem('last_page_visited');

    let pageVisitCount = parseInt(sessionStorage.getItem(pageCountKey) || '0') + 1;
    let pageTimes = JSON.parse(sessionStorage.getItem(pageTimesKey) || '[]');

    const now = Date.now();
    pageTimes.push(now);

    if (pageTimes.length > 20) {
        pageTimes = pageTimes.slice(-20);
    }

    // Reset scroll tracking for new page
    if (currentURL !== lastPageKey) {
        if (window.scrollData) {
            window.scrollData.maxScrollReached = 0;
            window.scrollData.currentScroll = 0;
            window.scrollData.lastScrollTime = now;
        }
    }

    // Store updated data
    sessionStorage.setItem(pageCountKey, pageVisitCount.toString());
    sessionStorage.setItem(pageTimesKey, JSON.stringify(pageTimes));
    sessionStorage.setItem('last_page_visited', currentURL);

    // FIXED: Single page visit track with proper delay and safeguards
    setTimeout(() => {
        if (window.tracker && typeof window.tracker.pageVisit === 'function') {
            // FIXED: Only track if we haven't already tracked this specific load
            if (sessionStorage.getItem(pageLoadKey)) {
                window.tracker.pageVisit(pageType, pageName, pageVisitCount, pageTimes);
            }
        }
    }, 1000);

    // Product page auto-tracking
    if (path.includes('/products/')) {
        const productId = path.split('/products/')[1].split('?')[0];

        // Get product data from Shopify meta or page
        const productData = window.meta?.product || {};
        const productName = productData.title || document.querySelector('h1')?.textContent || '';
        const productPrice = productData.price || extractPriceFromPage() || 0;
        const productCategory = productData.type || '';

        tracker.viewContent(productId, productName, productCategory, productPrice);

        // Track high engagement after 60 seconds
        setTimeout(() => {
            tracker.highProductEngagement(productId, 60);
        }, 60000);
    }

    // Sustainability page tracking
    if (path.toLowerCase().includes('sustainability')) {
        const startTime = Date.now();

        // Track engagement at different time intervals
        setTimeout(() => {
            tracker.sustainabilityEngaged(30, 'medium_engagement');
        }, 30000);

        setTimeout(() => {
            tracker.sustainabilityEngaged(120, 'deep_engagement');
        }, 120000);

        // Track total time on page exit
        window.addEventListener('beforeunload', () => {
            const timeSpent = Math.floor((Date.now() - startTime) / 1000);
            if (timeSpent > 10) { // Only track if meaningful time
                tracker.sustainabilityEngaged(timeSpent, 'exit_tracking');
            }
        });
    }

    // Soil-to-soil page tracking  
    if (path.toLowerCase().includes('soil') || path.toLowerCase().includes('lifecycle')) {
        const startTime = Date.now();

        setTimeout(() => {
            tracker.soilToSoilEngaged(30, 'medium_engagement');
        }, 30000);

        window.addEventListener('beforeunload', () => {
            const timeSpent = Math.floor((Date.now() - startTime) / 1000);
            if (timeSpent > 10) {
                tracker.soilToSoilEngaged(timeSpent, 'exit_tracking');
            }
        });
    }

})();

// ===========================================
// EVENT LISTENERS FOR USER INTERACTIONS
// ===========================================


let lastClickTime = 0;
let lastClickPath = '';

document.addEventListener('click', function (e) {
    const now = Date.now();

    // Create a unique click path (helps with nested element bubbling)
    const clickPath = e.composedPath().map(el => el.tagName || '').join('>');

    // Debounce: if last click was < 300ms ago with same path, skip
    if (now - lastClickTime < 300 && lastClickPath === clickPath) return;
    lastClickTime = now;
    lastClickPath = clickPath;

    const addToCartSelectors = [
        '[data-add-to-cart]',
        '.add-to-cart',
        '.btn--add-to-cart',
        '.product-form__cart-submit',
        '[name="add"]',
        'button[data-add-to-cart]',
        '.add-to-cart-button',
        '.product-add-to-cart',
        '.btn-add-to-cart',
        '[data-shopify="add-to-cart"]',
        '.shopify-payment-button button',
        '.cart-add-button'
    ];

    const addToCartElement = e.target.closest(addToCartSelectors.join(', '));

    // If matched by selector, skip text match entirely (avoid double match)
    let matchedElement = addToCartElement;
    if (!matchedElement) {
        const buttonText = e.target.textContent?.toLowerCase() || '';
        const isAddToCartByText =
            (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT') &&
            (buttonText.includes('add to cart') ||
                buttonText.includes('add to bag') ||
                buttonText.includes('buy now'));

        if (isAddToCartByText) matchedElement = e.target;
    }

    if (!matchedElement) return;

    // Enhanced form detection
    const productForm = matchedElement.closest('form[action*="/cart/add"]') ||
        matchedElement.closest('.product-form') ||
        matchedElement.closest('form') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('.product-form');

    const productData = extractProductDataFromPage();

    if (productForm) {
        const formData = new FormData(productForm);
        const variantId = formData.get('id') ||
            formData.get('variant_id') ||
            matchedElement.dataset.variantId ||
            productForm.querySelector('[name="id"]')?.value;

        const quantity = parseInt(
            formData.get('quantity') ||
            matchedElement.dataset.quantity ||
            productForm.querySelector('[name="quantity"]')?.value ||
            '1'
        );

        const productName = productData.name ||
            matchedElement.dataset.productTitle ||
            document.querySelector('h1')?.textContent?.trim() || '';

        const productPrice = productData.price ||
            parseFloat(matchedElement.dataset.price || '0');

        tracker.addToCart(
            variantId || productData.id,
            productName,
            productData.category,
            productPrice,
            quantity
        );
    } else {
        tracker.addToCart(
            productData.id,
            productData.name,
            productData.category,
            productData.price,
            1
        );
    }
}, true); // capture phase



async function getCartData() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  // Enrich each item with full title (product + variant) and image
  const enrichedItems = cart.items.map(item => ({
    variant_id: item.variant_id,
    product_id: item.product_id,
    quantity: item.quantity,
    name: item.variant_title && item.variant_title !== 'Default Title'
      ? `${item.product_title} - ${item.variant_title}`
      : item.product_title,
    title: item.product_title,
    variant_title: item.variant_title === 'Default Title' ? '' : item.variant_title,
    price: item.price / 100,
    sku: item.sku || "",
    handle: item.handle,
    image: item.image ? item.image : null
  }));

  return {
    items: enrichedItems,
    total: cart.total_price / 100
  };
}

async function handleEgyptCheckout() {
  try {
    const countryRes = await fetch("https://ipapi.co/country/");
    const country = (await countryRes.text()).trim();
    console.log("Country:", JSON.stringify(country));

    if (country !== "EG") return false;

    console.log("🇪🇬 Egypt detected");

    try {
      const cartData = await getCartData();

      if (cartData) {
        console.log("🛒 Cart payload:", JSON.stringify(cartData, null, 2));

        const response = await fetch("https://paymob-eight.vercel.app/api/checkout/render", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartData)
        });

        const data = await response.json();
        console.log("💳 Backend response:", data);

        if (data.success && data.redirectUrl) {
          window.location.href = data.redirectUrl;
          return true;
        }
      }
    } catch (e) {
      console.warn("⚠️ Payload failed, redirecting anyway:", e);
    }

  } catch (error) {
    console.error("❌ Egypt checkout error:", error);
    return false;
  }
}

document.addEventListener('click', function (e) {
  if (!e.target || typeof e.target.closest !== 'function') return;

  const checkoutElement = e.target.closest('.checkout__button, [name="checkout"], .checkout-button, [href*="checkout"], .cart__checkout, .btn--checkout');

  if (checkoutElement) {
    e.preventDefault();
    e.stopPropagation();

    (async () => {
      const [cartData, wasRedirected] = await Promise.all([
        getCartData().catch(() => null),
        handleEgyptCheckout()
      ]);

      if (cartData) {
        tracker.initiateCheckout(cartData.total, '', cartData.items);
      }

      if (!wasRedirected) {
        window.location.href = '/checkout';
      }
    })();
  }
}, true);

// Search tracking - ONLY query
document.addEventListener('input', function (e) {
    if (e.target.matches('.search-input, [name="q"], .search-bar input') && e.target.value.length > 2) {
        clearTimeout(window.searchTimeout);
        window.searchTimeout = setTimeout(() => {
            tracker.searchPerformed(e.target.value);
        }, 1000); // Debounce search tracking
    }
});

// Email capture tracking - Enhanced for ALL forms

// Add button click listener for Klaviyo forms
// document.addEventListener('click', function(e) {
//     const button = e.target.closest('button, input[type="submit"]');
//     if (button) {
//         const emailInput = document.querySelector('input[type="email"]:not([value=""])');
//         if (emailInput && emailInput.value && emailInput.value.includes('@')) {
//             let source = 'button_submit';
//             if (emailInput.closest('footer')) source = 'footer_submit';
//             else if (emailInput.closest('.popup, .modal, .drawer')) source = 'popup_submit';
            
//             tracker.emailCaptured(emailInput.value, source);
//         }
//     }
// });

// // Also track email input changes (for popups that don't submit)
document.addEventListener('change', function (e) {
    if (e.target.type === 'email' && e.target.value) {
        const email = e.target.value;
        if (email.includes('@') && email.includes('.')) {


            let source = 'email_input';
            if (e.target.closest('footer')) source = 'footer_input';
            else if (e.target.closest('.popup, .modal, .drawer')) source = 'popup_input';

            tracker.emailCaptured(email, source);
        }
    }
});

// SOPHISTICATED Multiple product view tracking
(function () {
    if (!window.location.pathname.includes('/products/')) return;

    const currentProductId = window.location.pathname.split('/products/')[1].split('?')[0];
    const viewedProducts = JSON.parse(sessionStorage.getItem('viewed_products') || '[]');
    const sessionStart = parseInt(sessionStorage.getItem('session_start_time') || Date.now().toString());
    const now = Date.now();

    // Don't count same product twice
    if (viewedProducts.includes(currentProductId)) return;

    viewedProducts.push(currentProductId);
    sessionStorage.setItem('viewed_products', JSON.stringify(viewedProducts));

    const productViewCount = viewedProducts.length;
    const sessionDuration = Math.floor((now - sessionStart) / 1000); // seconds



    // SOPHISTICATED LOGIC:
    // 3+ products = browsing behavior
    // 5+ products = heavy browsing 
    // 3+ in under 2 minutes = quick browsing (price comparison)
    // 3+ with long time = careful consideration

    if (productViewCount === 3) {
        const browsingSpeed = sessionDuration < 120 ? 'fast' : 'slow';
        tracker.multipleProductViews(productViewCount, browsingSpeed, sessionDuration);
    } else if (productViewCount === 5) {
        tracker.multipleProductViews(productViewCount, 'heavy_browser', sessionDuration);
    } else if (productViewCount >= 8) {
        tracker.multipleProductViews(productViewCount, 'extensive_browser', sessionDuration);
    }

    // Set session start time if not set
    if (!sessionStorage.getItem('session_start_time')) {
        sessionStorage.setItem('session_start_time', now.toString());
    }
})();

// Video tracking (if you have videos)
document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('video, iframe[src*="youtube"], iframe[src*="vimeo"]');

    videos.forEach(video => {
        if (video.tagName === 'VIDEO') {
            let tracked25 = false, tracked50 = false, tracked75 = false, tracked100 = false;

            video.addEventListener('timeupdate', function () {
                const percent = (video.currentTime / video.duration) * 100;
                const title = video.dataset.title || video.closest('[data-video-title]')?.dataset.videoTitle || 'Unknown Video';

                if (percent >= 25 && !tracked25) {
                    tracker.videoWatched(title, 25, video.duration);
                    tracked25 = true;
                } else if (percent >= 50 && !tracked50) {
                    tracker.videoWatched(title, 50, video.duration);
                    tracked50 = true;
                } else if (percent >= 75 && !tracked75) {
                    tracker.videoWatched(title, 75, video.duration);
                    tracked75 = true;
                } else if (percent >= 100 && !tracked100) {
                    tracker.videoWatched(title, 100, video.duration);
                    tracked100 = true;
                }
            });
        }
    });
});

// ===========================================
// HELPER FUNCTIONS FOR SHOPIFY DATA EXTRACTION
// ===========================================

function extractProductDataFromPage() {
    // Try to get from Shopify product object
    if (typeof meta !== 'undefined' && meta.product) {
        return {
            id: meta.product.id,
            name: meta.product.title,
            price: meta.product.price / 100,
            category: meta.product.type
        };
    }

    // Fallback to DOM extraction
    return {
        id: getCurrentProductId(),
        name: document.querySelector('h1, .product-title')?.textContent?.trim() || '',
        price: extractPriceFromPage(),
        category: document.querySelector('.product-type, .breadcrumb')?.textContent?.trim() || ''
    };
}

function getCurrentProductId() {
    if (typeof meta !== 'undefined' && meta.product?.id) {
        return meta.product.id.toString();
    }

    const path = window.location.pathname;
    if (path.includes('/products/')) {
        return path.split('/products/')[1].split('?')[0];
    }

    return null;
}

function extractPriceFromPage() {
    const priceSelectors = [
        '.price, .product-price, [data-price], .money',
        '.price-current, .sale-price, .regular-price'
    ];

    for (const selector of priceSelectors) {
        const priceEl = document.querySelector(selector);
        if (priceEl) {
            const priceText = priceEl.textContent.replace(/[^\d.]/g, '');
            const price = parseFloat(priceText);
            if (!isNaN(price)) return price;
        }
    }

    return 0;
}


// Judge.me reviews engagement with prolonged hover
document.addEventListener('mouseenter', function (e) {
    const judgeReviewElement = e.target.closest('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg, .jdgm-star, .jdgm-write-rev-link');
    const generalReviewElement = e.target.closest('.reviews, .testimonials, .social-proof, .rating, .review-stars, [data-reviews], .review, .review-item, .product-reviews, .star-rating, .rating-stars, [class*="review"], [class*="rating"], [id*="review"], [id*="rating"]');

    const reviewElement = judgeReviewElement || generalReviewElement;

    if (reviewElement && !reviewElement.dataset.hoverTracked) {
        let hoverTimer;

        const startHover = () => {
            hoverTimer = setTimeout(() => {

                const productId = getCurrentProductId();
                tracker.socialProofEngaged('reviews', productId);
                reviewElement.dataset.hoverTracked = 'true';
            }, 2000); // 2 second hover
        };

        const endHover = () => {
            clearTimeout(hoverTimer);
        };

        reviewElement.addEventListener('mouseenter', startHover);
        reviewElement.addEventListener('mouseleave', endHover);

        startHover(); // Start timer immediately
    }
});

// Enhanced scroll tracking with content-awareness and engagement timing
window.scrollData = {
    maxScrollReached: 0,
    currentScroll: 0,
    lastScrollTime: 0,
    scrollStartTime: Date.now(),
    trackedMilestones: new Set(),
    readingTime: 0, // Time spent in readable areas
    contentSections: [], // Detected content areas
    engagementZones: new Map() // Time spent in different scroll zones
};

let scrollTimeout;
let scrollThrottleTimeout;
let readingTimer;

// Initialize content detection on page load
document.addEventListener('DOMContentLoaded', function () {
    detectContentSections();
});

function detectContentSections() {
    const contentSelectors = [
        'main', 'article', '.content', '.post-content',
        '.product-description', '.page-content', 'section',
        'p', 'h1', 'h2', 'h3', 'ul', 'ol'
    ];

    const sections = [];

    contentSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
            if (el.offsetHeight > 100 && el.textContent.trim().length > 50) {
                const rect = el.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                sections.push({
                    element: el,
                    top: rect.top + scrollTop,
                    bottom: rect.top + scrollTop + rect.height,
                    height: rect.height,
                    textLength: el.textContent.trim().length,
                    type: el.tagName.toLowerCase(),
                    isMainContent: el.matches('main, article, .content, .product-description')
                });
            }
        });
    });

    // Sort by position and remove overlaps
    window.scrollData.contentSections = sections
        .sort((a, b) => a.top - b.top)
        .filter((section, index, arr) => {
            // Remove sections that are completely contained within others
            return !arr.some((other, otherIndex) =>
                otherIndex !== index &&
                other.top <= section.top &&
                other.bottom >= section.bottom &&
                other.height > section.height
            );
        });
}

window.addEventListener('scroll', function () {
    // Throttle scroll events to improve performance
    if (scrollThrottleTimeout) return;

    scrollThrottleTimeout = setTimeout(() => {
        scrollThrottleTimeout = null;
    }, 16); // ~60fps throttling

    const now = Date.now();

    // Enhanced document height calculation
    const body = document.body;
    const html = document.documentElement;

    const documentHeight = Math.max(
        body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight
    );

    const windowHeight = window.innerHeight;
    const scrollTop = window.pageYOffset || html.scrollTop || body.scrollTop || 0;
    const viewportBottom = scrollTop + windowHeight;

    // Calculate scroll percentage (traditional)
    let scrollPercent = 0;
    if (documentHeight <= windowHeight) {
        scrollPercent = 100;
    } else {
        const scrollableHeight = documentHeight - windowHeight;
        scrollPercent = Math.min(Math.max((scrollTop / scrollableHeight) * 100, 0), 100);
    }

    // Update scroll data
    const precisePercent = Math.floor(scrollPercent * 100) / 100;
    window.scrollData.currentScroll = precisePercent;
    window.scrollData.lastScrollTime = now;

    if (precisePercent > window.scrollData.maxScrollReached) {
        window.scrollData.maxScrollReached = precisePercent;
    }

    // Content-aware engagement tracking
    trackContentEngagement(scrollTop, viewportBottom, now);

    // Debounced milestone tracking
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
        trackScrollMilestones(now);
    }, 150);

    // Start/update reading timer for content areas
    updateReadingTime(scrollTop, viewportBottom, now);
});

function trackContentEngagement(scrollTop, viewportBottom, timestamp) {
    const currentZone = Math.floor(window.scrollData.currentScroll / 10) * 10; // 0%, 10%, 20%, etc.
    const zoneKey = `zone_${currentZone}`;

    if (!window.scrollData.engagementZones.has(zoneKey)) {
        window.scrollData.engagementZones.set(zoneKey, {
            firstEnter: timestamp,
            totalTime: 0,
            lastEnter: timestamp
        });
    } else {
        const zone = window.scrollData.engagementZones.get(zoneKey);
        zone.lastEnter = timestamp;
    }

    // Update total time for all zones (simplified approach)
    window.scrollData.engagementZones.forEach((zone, key) => {
        if (key === zoneKey) {
            zone.totalTime += 100; // Add 100ms (our throttle interval)
        }
    });
}

function updateReadingTime(scrollTop, viewportBottom, timestamp) {
    // Check if user is in a content-rich area
    const visibleContent = window.scrollData.contentSections.filter(section => {
        return (section.top < viewportBottom && section.bottom > scrollTop);
    });

    const isInContentArea = visibleContent.some(section => section.isMainContent);

    if (isInContentArea) {
        if (!readingTimer) {
            readingTimer = timestamp;
        }
    } else {
        if (readingTimer) {
            window.scrollData.readingTime += timestamp - readingTimer;
            readingTimer = null;
        }
    }
}

function trackScrollMilestones(timestamp) {
    const currentScroll = window.scrollData.maxScrollReached;
    const currentPath = window.location.pathname;
    const sessionDuration = timestamp - window.scrollData.scrollStartTime;
    const readingTime = window.scrollData.readingTime + (readingTimer ? timestamp - readingTimer : 0);

    // Traditional percentage milestones
    const percentageMilestones = [25, 50, 75, 90, 100];

    percentageMilestones.forEach(milestone => {
        const milestoneKey = `${currentPath}_${milestone}`;

        if (currentScroll >= milestone && !window.scrollData.trackedMilestones.has(milestoneKey)) {
            window.scrollData.trackedMilestones.add(milestoneKey);

            // Calculate engagement quality
            const timeToReach = sessionDuration / 1000; // seconds
            const readingRatio = readingTime / sessionDuration;
            const scrollSpeed = milestone / timeToReach; // % per second

            let engagementQuality = 'medium';
            if (scrollSpeed < 5 && readingRatio > 0.6) engagementQuality = 'high'; // Slow scroll, high reading time
            else if (scrollSpeed > 20 && readingRatio < 0.3) engagementQuality = 'low'; // Fast scroll, low reading time

            if (window.tracker && typeof window.tracker.track === 'function') {
                window.tracker.track('scroll_milestone', {
                    milestone: milestone,
                    exact_percentage: currentScroll,
                    page_path: currentPath,
                    time_to_reach_seconds: Math.floor(timeToReach),
                    reading_time_seconds: Math.floor(readingTime / 1000),
                    reading_time_ratio: Math.round(readingRatio * 100) / 100,
                    scroll_speed_percent_per_second: Math.round(scrollSpeed * 100) / 100,
                    engagement_quality: engagementQuality,
                    content_sections_visible: window.scrollData.contentSections.length,
                    timestamp: timestamp
                });
            }
        }
    });

    // Deep engagement tracking (5+ minutes of quality reading)
    if (readingTime > 300000 && sessionDuration > 300000) { // 5 minutes
        const deepEngagementKey = `${currentPath}_deep_engagement`;
        if (!window.scrollData.trackedMilestones.has(deepEngagementKey)) {
            window.scrollData.trackedMilestones.add(deepEngagementKey);

            if (window.tracker && typeof window.tracker.track === 'function') {
                window.tracker.track('deep_content_engagement', {
                    page_path: currentPath,
                    total_reading_time_seconds: Math.floor(readingTime / 1000),
                    session_duration_seconds: Math.floor(sessionDuration / 1000),
                    engagement_ratio: Math.round((readingTime / sessionDuration) * 100) / 100,
                    max_scroll_reached: currentScroll,
                    timestamp: timestamp
                });
            }
        }
    }
}


(function () {
    if (window.location.pathname.includes('/thank_you') ||
        window.location.pathname.includes('/orders/') ||
        window.location.search.includes('checkout=complete')) {

        const extractItemsFromThankYouPage = () => {
            const items = [];
            const itemSelectors = [
                '.line-item',
                '.order-summary__sections .line-item',
                '.os-step__line-item', // some themes
                '.order-items .order-item'
            ];

            for (const selector of itemSelectors) {
                document.querySelectorAll(selector).forEach(itemEl => {
                    const name = itemEl.querySelector('.line-item__title, .product-name, .os-step__product-title')?.textContent?.trim() || 'Unknown';
                    const quantity = parseInt(itemEl.querySelector('.line-item__quantity, .quantity, .os-step__quantity')?.textContent?.trim()) || 1;
                    const price = parseFloat(itemEl.querySelector('.line-item__price, .total-price, .os-step__price')?.textContent?.replace(/[^\d.]/g, '')) || 0;
                    items.push({ id: null, name, price, quantity, category: '' });
                });
                if (items.length) break; // stop if we found items
            }

            return items;
        };

        const getOrderNumber = () => {
            const selectors = [
                '[data-order-number]',
                '.order-number',
                '.os-step__order-number',
                '.thank-you__order-number'
            ];
            for (const sel of selectors) {
                const el = document.querySelector(sel);
                if (el && el.textContent.trim()) return el.textContent.trim();
            }
            return `order_${Date.now()}`;
        };

        const getTotal = () => {
            const selectors = [
                '[data-checkout-payment-due-target]',
                '.payment-due',
                '.order-total',
                '.total-line__price',
                '.os-step__total',
                '.thank-you__total'
            ];
            for (const sel of selectors) {
                const el = document.querySelector(sel);
                if (el && el.textContent.trim()) return parseFloat(el.textContent.replace(/[^\d.]/g, ''));
            }
            return 0;
        };

        const getEmail = () => {
            const selectors = [
                '[data-customer-email]',
                '.customer-email',
                '.os-step__email',
                '.thank-you__email'
            ];
            for (const sel of selectors) {
                const el = document.querySelector(sel);
                if (el && el.textContent.trim()) return el.textContent.trim();
            }
            return null;
        };

        const trackPurchase = () => {
            const orderData = {
                orderId: getOrderNumber(),
                total: getTotal(),
                items: extractItemsFromThankYouPage(),
                currency: 'USD', // optionally detect from page if needed
                email: getEmail()
            };

            if (tracker) {
                const purchaseKey = `purchase_tracked_${orderData.orderId}`;
                if (localStorage.getItem(purchaseKey)) return;
                localStorage.setItem(purchaseKey, Date.now().toString());

                tracker.purchase(orderData.orderId, orderData.total, orderData.currency, orderData.items);

                if (orderData.email && tracker.identify) {
                    tracker.identify(orderData.email);
                }
            }
        };

        setTimeout(trackPurchase, 1000); // slight delay to ensure page fully loads
    }
})();

(function() {
    // Utility: get filter group name from checkbox/radio name
    const getFilterGroup = (input) => {
        const name = input.name || '';
        // Example: "filter.v.option.color" -> "color"
        const parts = name.split('.');
        return parts[parts.length - 1] || 'unknown';
    };

    // Track the filter event (replace with your analytics function)
    const trackFilterClick = (group, value, type) => {
        console.log('Filter clicked:', { group, value, type, page: window.location.pathname });
        // Example: send to GA4 or Meta Pixel
        window.tracker.track('filter_click', { filter_group: group, filter_value: value, filter_type: type });
    };

    // Attach event listeners to all current and future filter checkboxes/radios
    const observeFilters = () => {
        const container = document.querySelector('[data-collection-sidebar]');
        if (!container) return;

        const attachListener = (input) => {
            if (input.dataset.tracked) return;
            input.addEventListener('change', () => {
                const group = getFilterGroup(input);
                trackFilterClick(group, input.value, input.type);
            });
            input.dataset.tracked = true;
        };

        // Initial attach
        container.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(attachListener);

        // Watch for dynamic changes (themes with AJAX filtering)
        const observer = new MutationObserver(() => {
            container.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(attachListener);
        });

        observer.observe(container, { childList: true, subtree: true });
    };

    // Track sort clicks
    const observeSort = () => {
        document.querySelectorAll('[data-sort-link]').forEach(link => {
            if (link.dataset.tracked) return;
            link.addEventListener('click', (e) => {
                e.preventDefault(); // optional
                const value = link.dataset.value || link.textContent.trim();
                console.log('Sort clicked:', { value, page: window.location.pathname });
                link.dataset.tracked = true;
            });
        });
    };

    // Init
    observeFilters();
    observeSort();

})();


